<template>
    <div class="modal-search fixed hidden top-0 left-0 w-full h-full z-30">

        <div class="absolute block w-full h-full bg-gray-900 z-10 opacity-60"></div>


        <div class="modal-search-close fixed top-2 right-2 text-white cursor-pointer z-30">
            <span class="icon-times text-2xl" @click="$eventbus.$emit('search:modal:hide')"></span>
        </div>

        <div class="modal-search-input relative bg-dodger_blue z-20">
            <div class="container mx-auto px-3 py-5 flex justify-center items-center">

                <div>
                    <div class="modal-search-input__keyword ">
                        <input type="text" @keyup.enter="search()" v-model="searchKeyword" placeholder="Rechercher"
                               class="w-60 border-0 pl-3 pr-6  py-1 bg-transparent text-white"
                        />
                    </div>

                    <div v-if="searchKeyword.length >= 3" class="modal-search-input__results absolute block px-3 py-3 top-12 bg-white w-60 shadow-xl">
                        <!-- find -->
                        <template v-if="find">
                            <div class="border-b">
                                <div @click="searchKeyword = (find.data[0].word).toString(); search();"
                                     class="cursor-pointer"
                                >
                                    {{ find.data[0].word }}
                                </div>
                            </div>
                        </template>
                        <!-- find by lev -->
                        <template v-if="findByLev.length">
                            <div class="border-b">
                                <template v-for="(result, idx_result) in $options.filters.maximumLev( findByLev )">
                                    <div @click="searchKeyword = (result.keyword).toString(); search();"
                                         class="cursor-pointer"
                                    >
                                        {{ result.keyword }}
                                    </div>
                                </template>
                            </div>
                        </template>
                        <!-- -autocomplete -->
                        <template v-if="results.length > 1 || ((results.length === 1) && (results[0].word.toLowerCase() !== searchKeyword.toLowerCase())) ">
                            <div>
                                <template v-for="(result, idx_result) in $options.filters.maximum( results )">
                                    <template v-if="result.word.toLowerCase() !== searchKeyword.toLowerCase()">
                                        <div @click="searchKeyword = (result.word).toString(); search();"
                                             class="cursor-pointer"
                                        >
                                            <span v-html=" highlitAutocomplete(searchKeyword, result.word) "></span>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </template>

                        <template v-if="!(find || findByLev.length || results.length)">
                            No results!
                        </template>
                    </div>
                </div>

                <button class="w-2 -ml-5 mr-7  bg-transparent text-white" @click="searchKeyword = '' ">
                    <span v-if="searchKeyword" class="icon-times"></span>
                </button>

                <button @click="search()" class=" bg-transparent text-white">
                    <span class="icon-search"></span>
                </button>
            </div>
            <div></div>
        </div>

        <div v-if="searchKeywordTemp" class="modal-search-results relative z-10 bg-white h-screen overflow-auto" style="max-height: calc( 100% - 72px )">

            <div class="container mx-auto px-3">
                <h3 class="text-center text-dodger_blue text-2xl py-16">{{ totalResults.length }} résultats de recherche pour «&nbsp; {{ searchKeywordTemp }} &nbsp;»</h3>
            </div>

            <div class="container mx-auto px-3" v-if="contentResults.length">
                <h3 class="text-left text-dodger_blue text-xl py-16">{{ contentResults.length }} articles</h3>
                <!-- {{ contentResults }}-->
                <div class="flex flex-row flex-wrap justify-center items-center">
                    <template v-for="result in contentResults">
                        <div class="w-64 h-auto m-3 inline-block relative">
                            <modal-search-box :options="{
                                data: result,
                                type: 'content'
                            }"/>
                        </div>
                    </template>
                </div>
            </div>

            <div class="container mx-auto px-3" v-if="imagesResults.length">
                <h3 class="text-left text-dodger_blue text-xl py-16">{{ imagesResults.length }} photos</h3>
                <!-- {{ imagesResults }}-->
                <div class="flex flex-row flex-wrap justify-center items-center">
                    <template v-for="result in imagesResults">
                        <div class="w-64 h-64 m-3 inline-block relative">
                            <modal-search-box :options="{
                                data: result,
                                type: 'images'
                            }"/>
                        </div>
                    </template>
                </div>
            </div>

            <div class="container mx-auto px-3" v-if="richmediaResults.length">
                <h3 class="text-left text-dodger_blue text-xl py-16">{{ richmediaResults.length }} vidéos</h3>
                <!--{{ richmediaResults }}-->
                <div class="flex flex-row flex-wrap justify-center items-center">
                    <template v-for="result in richmediaResults">
                        <div class="w-64 h-64 m-3 inline-block relative">
                            <modal-search-box :options="{
                                data: result,
                                type: 'richmedia'
                            }"/>
                        </div>
                    </template>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import SearchMixins from "../mixins/SearchMixins";
import ModalSearchBox from "./ModalSearchBox";

export default {
    name: "ModalSearch",
    components: {ModalSearchBox},
    mixins: [SearchMixins],
    data() {
        return {
            searchKeyword: '',
            searchKeywordTemp: '',
            searchResultsTemp: [],
            //
            totalResults: [],
            contentResults: [],
            imagesResults: [],
            richmediaResults: [],
        }
    },
    methods: {

        cleanFields() {
            const vm = this;

            vm.searchKeyword = '';
            vm.searchKeywordTemp = '';
            vm.searchResultsTemp = [];
            //
            vm.totalResults = [];
            vm.contentResults = [];
            vm.imagesResults = [];
            vm.richmediaResults = [];
        },

        search() {
            const vm = this;
            vm.searchKeywordTemp = vm.searchKeyword.toLowerCase().trim();
            vm.searchKeyword = '';
            //
            vm.searchResultsTemp = vm.searchResults(vm.searchKeywordTemp);
            //
            vm.totalResults = vm.TotalResults(vm.searchResultsTemp);
            vm.contentResults = vm.ContentResults(vm.searchResultsTemp);
            vm.imagesResults = vm.ImagesResults(vm.searchResultsTemp);
            vm.richmediaResults = vm.RichmediaResults(vm.searchResultsTemp);


            $eventbus.$emit('gtag', {
                method:'event',
                action: 'search',
                params:{
                    event_category : 'general',
                    event_label : 'searck keyword',
                    value : vm.searchKeywordTemp,
                }
            });
        },

        show() {
            const vm = this;
            //
            vm.cleanFields();
            //
            vm.$el.classList.remove('hidden');
            vm.$el.classList.add('block');
            //

            document.body.classList.add('overflow-hidden');
        },
        hidden() {
            const vm = this;
            //
            vm.$el.classList.remove('block');
            vm.$el.classList.add('hidden');
            //

            document.body.classList.remove('overflow-hidden');
            //

            vm.searchKeyword = '';
        }
    },
    mounted() {
        const vm = this;

        $eventbus.$on('search:modal:show', vm.show);
        $eventbus.$on('search:modal:hide', vm.hidden);
    }
}
</script>

<style scoped lang="scss">

.modal-search-input__keyword {
    input {
        &:focus-visible {
            border-radius: 0 !important;
            outline: none;
        }


        &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
            @apply text-white;
            opacity: 1; /* Firefox */
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            @apply text-white;
        }

        &::-ms-input-placeholder { /* Microsoft Edge */
            @apply text-white;
        }
    }
}

.modal-search-input__results {
    & div:last-child {
        border: none !important;
    }
}

</style>
